export const KIND = {
  scale: "scale" as const,
  foundation: "foundation" as const,
  semantic: "semantic" as const,
}
